enum OcurrenceVisibilityStatus {
    Private = 1,
    PublicSector = 2,
    PublicAll = 3
}

export default OcurrenceVisibilityStatus;